"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UfoRectangle = void 0;
var rectangle_1 = require("../rectangle/rectangle");
var CutUfoHelper_1 = require("../../utils/CutUfoHelper");
var UfoRectangle = /** @class */ (function (_super) {
    __extends(UfoRectangle, _super);
    function UfoRectangle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UfoRectangle.prototype.calculateHoleLines = function () {
        return [CutUfoHelper_1.CutUfoHelper.drawUfo(this.config.options)];
    };
    UfoRectangle.prototype.getConfigProperties = function () {
        return CutUfoHelper_1.CutUfoHelper.addProperties(_super.prototype.getConfigProperties.call(this));
    };
    return UfoRectangle;
}(rectangle_1.Rectangle));
exports.UfoRectangle = UfoRectangle;
